import { useContext } from 'react';

import {
  AuthenticationContext,
  OneRosterAuth,
} from '@/components/auth/auth.context';

export const useOneRosterAuth = (): OneRosterAuth => {
  return useContext(AuthenticationContext);
};
